<template>
  <div class="box">
    <div v-if="isCountryDK">
      <h1 class="primary-color">Kontakt os, hvis du ønsker at få fuld adgang til Docendo</h1>
      <ul class="docendo-contact-options">
        <li>
          <h4>Ring til os på</h4> <a href="tel:43310612">43 31 06 12</a>
        </li>
        <li>
          <h4>Skriv en en email</h4> <a href="mailto:kontakt@docendo.dk">kontakt@docendo.dk</a>
        </li>
        <li>
          <h4>Eller skriv en chatbesked</h4>
          <button class="bttn bttn--primary" @click="openCrispChat">Skriv en chatbesked</button>
        </li>
      </ul>
      <Pricing></Pricing>
    </div>
    <div v-if="!isCountryDK">
      <h1>{{ $t('vue.buy.buy_access_for_school_users') }}</h1>
      <div class="col-1-2 marg-20-bottom">
        <h4>{{ $t('vue.buy.a_user_is') }}</h4>
        <br>
        <h2 v-if="countryIsDkOrNo">{{ $t('vue.buy.choose_the_right_price') }}</h2>
        <br>
        <div class="marg-20-bottom flex" v-if="countryIsDkOrNo">
          <div class="col-1-2">
            <div @click="selectModel(1)" class="pointer border rounded pad-20 center"
                 :class="{'active': isSelectedModel(1), 'notActive': isSelectedModel(2)}">
              <h3 class="font-large marg-10-bottom">{{ $filters.capitalize($t('vue.buy.per_user')) }}</h3>
              <hr>
              <h3 class="marg-10-bottom">{{ $filters.capitalize($t('vue.buy.price')) }} {{ $t('vue.buy.per_user') }}</h3>
              <p class="text-blue bold blue-price">{{ userPrice }} {{ currency }}</p>
              <p>{{ $t('vue.buy.per_user') }} / {{ $t('vue.buy.month') }}</p>
              <br>
              <p class="marg-10-bottom">
                {{ $t('vue.buy.only_pay_per') }}
              </p>
              <button class="cta-button">
                {{ $t('repitition.choose') }}
              </button>
            </div>
          </div>
          <div class="col-1-2">
            <div @click="selectModel(2)" class="pointer pos-relative border rounded pad-20 center"
                 :class="{'active': isSelectedModel(2), 'notActive': isSelectedModel(1)}">
              <h3 class="font-large marg-10-bottom">{{ $t('vue.buy.unlimited') }}</h3>
              <hr>
              <h3 class="marg-10-bottom">{{ $t('vue.buy.total_student_number') }}</h3>
              <p class="text-blue bold blue-price">{{ pupilsPrice }} {{ currency }}</p>
              <p>{{ $t('vue.buy.per_student') }} / {{ $t('vue.buy.month') }}</p>
              <br>
              <p class="marg-10-bottom">{{ $t('vue.buy.pay_for_unlimited_users_and_get') }}</p>
              <button class="cta-button">{{ $t('repitition.choose') }}</button>
            </div>
          </div>
        </div>
        <div v-if="selectedModel !== null">
          <hr>
          <br>
          <h2>{{ $t('vue.buy.subscription_info') }}</h2>
          <br>
          <div v-if="isSelectedModel(1)">
            <div class="form-group large-margin form-group__input">
              <label>
                {{ $t('vue.buy.write_number_of_users') }}
              </label>
              <input type="number" v-model.number.lazy="users" class="type_number"/>
            </div>
          </div>
          <div v-if="isSelectedModel(2)">
            <div class="form-group large-margin form-group__input">
              <label>
                {{ $t('vue.buy.write_number_of_students') }}
              </label>
              <input type="number" class="type_number" v-model.number.lazy="pupils"/>
            </div>
          </div>
          <h3>{{ $t('vue.buy.billed_monthly_or_yearly') }}</h3>
          <div class="form-group large-margin form-group__radiobuttons">
            <br>
            <div>
              <input type="radio" id="monthly" value="1" v-model.number="interval">
              <label for="monthly">{{ $t('vue.buy.per_month') }}</label>
            </div>
            <div>
              <input type="radio" id="yearly" value="2" v-model.number="interval">
              <label for="yearly">{{ $t('vue.buy.per_year') }} <span
                class="discount">{{ $t('vue.buy.save_2') }} </span></label>
            </div>
          </div>

          <div class="billing-bill large-margin">
            <h2>{{ $t('vue.buy.your_invoice') }}</h2>
            <hr>
            <div class="flex">
              <p>1 {{ $t('vue.buy.institution') }}</p>
              <p>
                {{ yearlyPayment ? $t('vue.buy.per_year') : $t('vue.buy.per_month') }}
              </p>
              <p>
                {{ yearlyPayment ? monthlyInstitutionPrice * 12 : monthlyInstitutionPrice * 1 }} {{ currency }}
              </p>
            </div>
            <div class="flex" :class="{'invalid-price': selectedModel !== 1}">
              <p>{{ users === '' ? '0' : users }} <span>{{ $t('repitition.users') }}</span></p>
              <p>
                {{ yearlyPayment ? $t('vue.buy.per_year') : $t('vue.buy.per_month') }}
              </p>
              <p>
                {{ yearlyPayment ? userAmount * 12 : userAmount }} {{ currency }}
              </p>
            </div>
            <div class="flex" :class="{'invalid-price': selectedModel !== 2}">
              <p> {{ $t('vue.buy.unlimited') }}<span> {{ $t('repitition.users') }}</span></p>
              <p>
                {{ yearlyPayment ? $t('vue.buy.per_year') : $t('vue.buy.per_month') }}
              </p>
              <p>0 {{ currency }}</p>
            </div>
            <div class="flex" :class="{'invalid-price': selectedModel !== 2}">
              <p>{{ pupils === "" || pupils < 0 ? '0' : pupils }} <span>{{ $t('vue.buy.discount') }}</span></p>
              <p>
                {{ yearlyPayment ? $t('vue.buy.per_year') : $t('vue.buy.per_month') }}
              </p>
              <p>
                {{ yearlyPayment ? pupilAmount * 12 : pupilAmount }} {{ currency }}
              </p>
            </div>
            <div class="flex bg-discount" v-if="yearlyPayment">
              <p>{{ $t('vue.buy.discount') }}</p>
              <p>{{ $t('vue.buy.per_year') }}</p>
              <p>-{{ yearlySavings }} {{ currency }}</p>
            </div>
            <hr>
            <div class="flex">
              <p>{{ $t('vue.buy.total') }}</p>
              <p><span v-if="yearlyPayment">{{ $t('vue.buy.per_year') }}</span>
                <span v-else>{{ $t('vue.buy.per_month') }}</span>
              </p>
              <p class="total-amount">{{ totalAmount }} {{ currency }}</p>
            </div>
          </div>
          <hr>
          <br>
          <h2>{{ $t('vue.buy.payment_info') }}</h2>
          <br>
          <div class="form-group form-group__input">
            <label>{{ $t('vue.buy.school_name') }} *</label>
            <input type="text" v-model="schoolName"/>
          </div>
          <div class="form-group form-group__input">
            <label>{{ $filters.capitalize($t('vue.buy.your_name')) }} *</label>
            <input type="text" v-model="name"/>
          </div>
          <div class="form-group form-group__input">
            <label>{{ $t('vue.buy.your_email') }} *</label>
            <input type="text" v-model="email"/>
          </div>
          <div class="form-group form-group__input">
            <label>{{ $t('vue.buy.your_phonenumber') }} *</label>
            <input type="text" v-model="phone"/>
          </div>
          <button class="cta-button" @click="buyClick" :disabled="!buyButtonEnabled">
            {{ $t('vue.buy.buy') }}
          </button>
        </div>
      </div>

      <div class="col-1-2">
        <div class="center">
          <h2>{{ $t('vue.buy.questions') }} ?</h2>
          <h3>{{ $t('vue.buy.call_us_at') }} +45 43 31 06 12</h3>
        </div>
      </div>

      <modal :show="showModal" @close="closedModal" :close_on_click_away="true">
        <h1 slot="header">{{ modalHeader }}</h1>
        <div slot="body" class="flex flex-vertical-center"
             style="flex-direction: row; justify-content: center; align-items: center; height: 100%">
          <div v-html="modalBody"></div>
        </div>
        <div slot="footer"></div>
      </modal>
    </div>
  </div>
</template>

<script>
import docendo from '../docendo'
import modal from './Modal'
import Pricing from './Buy/Pricing.vue'

export default {
  components: {modal, Pricing},
  data () {
    return {
      // 1 = Pay Monthly, 2 = Pay yearly
      interval: 1,
      // 1 = pay per user, 2 = pay per student
      selectedModel: null,
      users: '',
      pupils: '',
      // Contact Info
      name: '',
      email: '',
      phone: '',
      schoolName: '',
      schoolEAN: '',
      showModal: false,
      modalHeader: '',
      modalBody: ''
    }
  },
  props: ['school'], // that is the school id in docendo
  exampleData: {
    school: 3
  },
  computed: {
    isChatActive () {
      return window.$crisp
    },
    country () {
      return window.SCHOOL.country.toLowerCase()
    },
    isCountryDK () {
      return this.country === 'dk'
    },
    countryIsDkOrNo () {
      return this.country === 'dk' || this.country === 'no'
    },
    currency () {
      if (this.country === 'dk') {
        return 'kr'
      } else if (this.country === 'no') {
        return 'kr'
      } else {
        return '€'
      }
    },
    monthlyInstitutionPrice () {
      if (this.country === 'dk') {
        return 499
      } else if (this.country === 'no') {
        return 499
      } else {
        return 50
      }
    },
    userPrice () {
      if (this.country === 'dk') {
        return 45
      } else if (this.country === 'no') {
        return 59
      } else {
        return 5
      }
    },
    pupilsPrice () {
      return this.country === 'dk' ? 5 : 6.5
    },
    buyButtonEnabled () {
      return this.name.length > 0 && this.email.length > 0 &&
        this.phone.length > 0 && this.schoolName.length > 0
    },
    userAmount () {
      return this.users < 0 ? 0 : this.users * this.userPrice
    },
    pupilAmount () {
      return this.pupils < 0 ? 0 : this.pupils * this.pupilsPrice
    },
    yearlyPayment () {
      return this.interval * 1 === 2
    },
    yearlySavings () {
      let total = (this.totalAmount * 1.02) * 0.02
      return total.toFixed(0)
    },
    totalAmount () {
      let total = 0

      if (this.selectedModel === 1) {
        if (this.yearlyPayment) {
          total = ((this.userAmount + this.monthlyInstitutionPrice) * 0.98) * 12
        } else {
          total = this.userAmount + this.monthlyInstitutionPrice
        }
      } else if (this.selectedModel === 2) {
        if (this.yearlyPayment) {
          total = ((this.pupilAmount + this.monthlyInstitutionPrice) * 0.98) * 12
        } else {
          total = this.pupilAmount + this.monthlyInstitutionPrice
        }
      } else {
        total = this.monthlyInstitutionPrice
      }
      return total.toFixed(0)
    }
  },
  methods: {
    selectModel (num) {
      this.selectedModel = num
    },
    isSelectedModel (num) {
      return this.selectedModel === num
    },
    buyClick () {
      this.showModal = true
      this.modalHeader = this.$i18n.t('repitition.processing')
      this.modalBody = '<h1>' + this.$i18n.t('repitition.one_moment') + '</h1>'
      docendo.schoolSubscribe(this.school,
        {
          name: this.name,
          user_count: this.selectedModel === 1 ? parseInt(this.users) : 0,
          pupil_count: this.selectedModel === 2 ? parseInt(this.pupils) : 0,
          pay_monthly: this.interval === 1,
          email: this.email,
          phone: this.phone,
          school_name: this.schoolName,
          ean: this.schoolEAN
        },
        this.buyCallbackSuccess, this.buyCallbackFailure)
    },
    buyCallbackSuccess (data) {
      this.showModal = true
      this.modalHeader = this.$i18n.t('vue.buy.thanks_for_buying')
      this.modalBody = '<a class="font-xlarge" href="/home">' + this.$i18n.t('vue.buy.go_to_home') + '</a>'
      this.$store.dispatch('analyticsOnSubscribe')
    },
    buyCallbackFailure (data) {
      console.log('buyCallbackFailure', data)
      console.log(data.full_messages)
      this.modalHeader = this.$i18n.t('vue.buy.error')
      this.modalBody = this.$i18n.t('vue.buy.missing_inputs')
      this.showModal = true
      // highlight failed fields
    },
    closedModal () {
      this.showModal = false
    },
    openCrispChat () {
      if (window.$crisp) {
        window.$crisp.push(['do', 'chat:open'])
      } else {
        console.error('Crisp is not loaded on this page.')
      }
    }
  },
  mounted () {
    this.$store.dispatch('analyticsOnVisitedBuy')
  },
  updated () {
    if (!this.countryIsDkOrNo) {
      this.selectModel(1)
    }
  }
}
</script>

<style scoped>

@import "../assets/css/variables.css";

.bg-discount {
  color: green
}

.active {
  border-color: var(--blue) !important;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
  transition: box-shadow .4s;
  background: white;
}

.notActive {
  opacity: 0.6;
  transition: all .4s;
}

h2 {
  color: #b0bac0;
  text-transform: uppercase;
}

.invalid-price {
  opacity: 0.5;
  display: none;
  text-decoration: line-through;
}

.billing-bill {
  border: 1px solid #cccccc;
  padding: 20px;
  border-radius: 3px;
}

.flex > p {
  flex: 1;
  font-weight: bold;
}

.flex > p:last-child {
  text-align: right;
  flex: 1.5;
}

.flex > p:nth-child(2) {
  color: #b0bac0;
  text-transform: uppercase;
}

.form-group.form-group__radiobuttons {
  display: flex;
}

.form-group.form-group__radiobuttons > div {
  padding-right: 20px;
}

.form-group.form-group__radiobuttons > div > input {
  width: auto;
  height: auto;
  margin-right: 5px;
}

.form-group__radiobuttons > div > input, .form-group__radiobuttons > div > label {
  display: inline-block;
  cursor: pointer;
}

.total-amount {
  font-size: 2em;
}

.discount {
  font-size: 0.75em;
  color: green;
  text-transform: uppercase;
}

.blue-price {
  font-size: 30px;
  line-height: 1.2em;
}

hr {
  border: 0;
  height: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.large-margin {
  margin-bottom: 25px;
}

.primary-color {
  color: var(--purple);
}

.docendo-contact-options li {
margin-bottom: 1rem;
}

.docendo-contact-options li a {
  font-size: 16px;
}

.docendo-contact-options .bttn {
  line-height: 32px;
}

</style>



// WEBPACK FOOTER //
// Buy.vue?cb9adea0